// Tabs simples (controlled). Patrón del DirectivoHeader del mockup
// analytics-directivo.jsx — border-bottom accent en el activo.
//
//   <Tabs value={tab} onChange={setTab}>
//     <Tab value="hoy">Hoy</Tab>
//     <Tab value="semana">Semana</Tab>
//   </Tabs>

import { createContext, useContext, type ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface TabsContextValue {
  value: string;
  onChange: (v: string) => void;
}
const TabsContext = createContext<TabsContextValue | null>(null);

export function Tabs({
  value,
  onChange,
  children,
  className,
}: {
  value: string;
  onChange: (v: string) => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <TabsContext.Provider value={{ value, onChange }}>
      <div
        role="tablist"
        className={cn('flex items-stretch gap-1 border-b border-border', className)}
      >
        {children}
      </div>
    </TabsContext.Provider>
  );
}

export function Tab({
  value,
  children,
  className,
}: {
  value: string;
  children: ReactNode;
  className?: string;
}) {
  const ctx = useContext(TabsContext);
  if (!ctx) throw new Error('<Tab> debe estar dentro de <Tabs>');
  const active = ctx.value === value;
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={() => ctx.onChange(value)}
      className={cn(
        '-mb-px px-4 py-2 text-sm transition-colors',
        active
          ? 'border-b-2 border-accent font-medium text-fg'
          : 'border-b-2 border-transparent text-fg-secondary hover:text-fg',
        className,
      )}
    >
      {children}
    </button>
  );
}
